import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService, DocumentService, UtilityService } from 'app/core/core.module';
import { Committee, CommitteeAttachment, CommitteeMember } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { MinutesEmailDialogComponent } from '../minutes-email-dialog/minutes-email-dialog.component';
import { Subject } from 'rxjs';
import { EmailDialogComponent } from 'app/shared/email-dialog/email-dialog.component';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';

@Component({
    selector: 'app-attachment-overview',
    templateUrl: './attachment-overview.component.html',
    styleUrls: ['./attachment-overview.component.scss'],
    standalone: false,
})
export class AttachmentOverviewComponent implements OnInit {
    result = new Subject<{ success: boolean; value?: any }>();
    documents: CommitteeAttachment[] = [];
    reviewOnly = true;
    committees: any;
    committeeId: number;
    executiveMembers: any;
    processing = false;
    serviceName = environment.serviceName;
    uploadHeaders: any;
    mode: string;
    showAsDialog = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private router: Router,
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
        private utility: UtilityService,
        private docService: DocumentService
    ) {}

    async ngOnInit() {
        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };

        if (this.showAsDialog) {
            this.mode = 'Executive Committee';
        } else {
            this.mode = this.router.url.indexOf('executive') > 0 ? 'Executive Committee' : 'Finance';
            this.committees = this.uow.lookups.committees;
            const committeeId = _.find(this.committees, { name: this.mode });
            this.committeeId = !!committeeId ? committeeId.id : null;
            this.executiveMembers = (await this.uow.getMembersByCommitteeIds([Committee.Committees.ExecutiveCommittee])) as CommitteeMember[];
            this.reviewOnly = this.mode === 'Executive Committee' && !this.auth.hasRole('Executive:Clerk');
        }
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.documents = (await this.uow.getCommitteeAttachments(this.committeeId, 'committee', this.auth.hasRole('Executive:Clerk') ? null : 1)) as any[];
        this.appInfo.pleaseWaitHide();
    }

    onSelectionChanged(e) {
        const rows = this.dataGrid.instance.getSelectedRowsData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    rowDoubleClick(e) {
        if (!!this.reviewOnly) return;
        this.openAttachment(e.data);
    }

    attachmentDoubleClick(e) {
        this.openAttachment(e.data);
    }

    openAttachment(attachment: CommitteeAttachment) {
        if (!attachment) return;
        window.open(attachment.filename, '_blank');
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!e.data.approved && !e.data.declined) {
                e.rowElement.className = e.rowElement.className + ' waiting-for-vote';
            }
        }
    }

    async rename() {
        const modalRef = this.modalService.show(AttachmentDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                fileUploaded: true,
                attachment: this.dataGrid.instance.getSelectedRowsData()[0],
                renameOnly: true,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            } else {
                this.uow.rollback();
            }
            modalRef.hide();
        });
    }

    async add(selectedRow?: any) {
        const modalRef = this.modalService.show(AttachmentDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // proposal: !!selectedRow ? selectedRow : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async email(mode?: string) {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const members = await this.uow.getMembersByCommitteeId(Committee.Committees.ExecutiveCommittee);

        const emailMessage = this.uow.committeeAttachmentEmails.createEntity({
            committeeId: Committee.Committees.ExecutiveCommittee,
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
        });

        let attachmentArray = [];
        selectedRows.forEach((row) => {
            attachmentArray.push({id: row.id, name: row.name});
        });

        const modalRef = this.modalService.show(EmailDialogComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // entity: selectedRows,
                emailMessage: emailMessage,
                selectedCommitteeId: Committee.Committees.ExecutiveCommittee,
                members: members,
                subject: `Graafschap Documents`,
                body: `Please see the attached file(s).`,
                mode: 'executive',
                attachments: attachmentArray,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (!!result && result.value) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                    await this.utility.emailAgendaDocumentPackage(null, emailMessage.id, result.memberIds);
                this.appInfo.pleaseWaitHide();
                const status = alert(`Email Sent!`, `${this.appInfo.settings.church.toUpperCase()}`);
            } else if (!result) this.uow.rollback();
            modalRef.hide();
            this.processing = false;
            await this.getData();
        });
    }

    async delete() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const result = await confirm(`Are you sure you want to delete?`, `GRRAFSCHAP`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const ids = selectedRows.map((x) => {
            return x.id;
        });
        await this.docService.deleteDocuments(ids);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
    async uploadStarted(e) {
        this.appInfo.pleaseWaitShow();
    }

    async uploaded(e) {
        if (e && e.request && e.request.responseText) {
            const fileResponses = JSON.parse(e.request.responseText);
            for (let idx = 0; idx < fileResponses.length; idx++) {
                const fileResponse = fileResponses[idx];
                // const attachment = this.uow.attachments.createEntity({
                //     bidId: this.bid.id,
                //     name: fileResponse.name,
                //     filename: fileResponse.filename,
                //     created: new Date(),
                //     createdBy: this.auth.currentUser.userName,
                // }) as Attachment;
                // this.bidAttachments.push(attachment);
            }
        }
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async uploadError(e) {
        await alert('An error occurred while attempting to upload the file(s)', `${this.appInfo.settings.church}`);
        this.appInfo.pleaseWaitHide();
    }

    async save() {
        this.processing = true;
        const attachments = this.dataGrid.instance.getSelectedRowsData();
        this.result.next({ success: true, value: attachments });
    }

    cancel() {
        this.processing = true;
        // this.uow.rollback();
        this.result.next({ success: false });
    }
}
